import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { TagModule } from '../../appshared/invoice/tag/tag.module';
import { TagService } from '../../appshared/invoice/tag/tag.service';

@Component({
  selector: 'app-occasion-categories',
  templateUrl: './occasion-categories.component.html',
  styleUrls: ['./occasion-categories.component.scss']
})
export class OccasionCategoriesComponent {

    public SelectedLanguage: string = "en";
    ComID: number = 2;
    public apiURL: string = "";
    public dataSourceTag = new MatTableDataSource<TagModule>();
    constructor(public router: Router, public translate: TranslateService, private servTag: TagService) {

        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';

    }

    ngOnInit(): void {
        this.fillTags();
    }

    fillTags() {
        //    this.loader.open();
        this.servTag.getService(this.ComID)
            .subscribe((res: TagModule[]) => {



                this.dataSourceTag.data = res;


            },
                (err: any) => {
                    console.log(err);
                });
    }




    onClickTag(tagId) {

        this.router.navigate(['shop', { tagId: tagId }]);
    }


    partnerSlidesOptions: OwlOptions = {
        loop: false,
        nav: false,
        dots: false,
        autoplayHoverPause: true,
        autoplay: true,
        margin: 30,
        rtl: true,
        navText: [
            "<i class='bx bx-right-arrow-alt'></i>",
            "<i class='bx bx-left-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
            1200: {
                items: 4
            }
        }
    }

}
